module.exports = __webpack_public_path__ + "static/media/search.937e6af3.svg";